export default {
  name: 'Product',
  props: {
    productName: {
      type: String,
      required: true,
      default() {
        return '';
      },
    },
    productImage: {
      type: String,
      default() {
        return '';
      },
    },
  },
};
